import { render, staticRenderFns } from "./file-library.vue?vue&type=template&id=04f8cebe&scoped=true&"
import script from "./file-library.vue?vue&type=script&lang=js&"
export * from "./file-library.vue?vue&type=script&lang=js&"
import style0 from "./file-library.vue?vue&type=style&index=0&id=04f8cebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8cebe",
  null
  
)

export default component.exports